import { PRODUCT_DETAILS_FAIL, PRODUCT_DETAILS_REQUEST, PRODUCT_DETAILS_SUCCESS, PRODUCT_LIST_FAIL, PRODUCT_LIST_REQUEST, PRODUCT_LIST_SUCCESS, PRODUCT_REVIEW_CREATE_FAIL, PRODUCT_REVIEW_CREATE_REQUEST, PRODUCT_REVIEW_CREATE_RESET, PRODUCT_REVIEW_CREATE_SUCCESS } from "../../constants/ProductListConstants";


export const ProductListReducer = (state = {loading:true, products:[]} , action) => {
    switch (action.type) {
        case PRODUCT_LIST_REQUEST:
            return {loading:  true}    
        case PRODUCT_LIST_SUCCESS:
            return {loading:  false, products:action.payload }
        case PRODUCT_LIST_FAIL:
            return {loading:  true, error:action.payload }

        default:
            return state;
    }
}

export const ProductDetailsReducer = (state={loading:true,product:{}},action)=>{
    switch (action.type) {
        case PRODUCT_DETAILS_REQUEST:
            return {loading:true}
        case PRODUCT_DETAILS_SUCCESS:
            return {loading:false, product:action.payload}
        case PRODUCT_DETAILS_FAIL:
            return {loading:false, error:action.payload}
    
        default:
            return state;
    }
}


//review by client
export const productReviewCreateReducer = (state = {}, action) => {
    switch (action.type) {
      case PRODUCT_REVIEW_CREATE_REQUEST:
        return { loading: true };
      case PRODUCT_REVIEW_CREATE_SUCCESS:
        return { loading: false, success: true, review: action.payload };
      case PRODUCT_REVIEW_CREATE_FAIL:
        return { loading: false, error: action.payload };
      case PRODUCT_REVIEW_CREATE_RESET:
        return {};
      default:
        return state;
    }
  };